<script lang="ts">
	import { _ } from 'svelte-i18n';
	import Card, { Content, Actions } from '@smui/card';
	import Title from '../..//shared/components/common/Title.svelte';
	import Input from '@smui/textfield';
	import { postData } from '../../shared/stores';
	import { writable } from 'svelte/store';
	import { push } from 'svelte-spa-router';
	import Button, { Label } from '@smui/button';

	const initialData = {
		userNameOrEmail: '',
	};
	let [data, loading, error] = [writable(initialData), writable(false), null];
	let dataResponse;
	function onSubmit() {
		[dataResponse, loading, error] = postData($data, 'api/usersmanagement/recuperopwd', () => push('/'));
		//[dataResponse, loading, error] = postData($data, "api/usersmanagement/recuperopwd", callLoginPage());
	}
	function callLoginPage() {
		//push('/');
	}
</script>

<div>
	<Card class="centralize px-8 pt-8 pb-10 md:h-[448px] md:w-[600px]" padded>
		<form on:submit|preventDefault="{onSubmit}">
			<Content>
				<Title title="{$_('page.user.recovery_password.title')}" />
				<div class="p-4">
					<div>
						<Input bind:value="{$data.userNameOrEmail}" class="w-full">
							<svelte:fragment slot="label">
								{$_('page.user.recovery_password.username_or_email')}<span class="required">*</span>
							</svelte:fragment>
						</Input>
					</div>
				</div>
			</Content>
			<Actions class="justify-center">
				<Button type="submit" variant="raised" class="w-[250px]">
					<Label>{$_('page.user.recovery_password.send')}</Label>
				</Button>
			</Actions>
		</form>
	</Card>
</div>
